import { Box } from "@material-ui/core";
// import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { checkinDetailSelector } from "Recoil/Checkins/selector";
import { checkArrayLength } from "src/utils";
import UserFilter from "./UserFilter";
import { useStyles } from "../styles";
import { DownloadDropDown } from "../../RightPanel/Common";

const HeaderFilters = ({
  selectedFrequency,
  setSelectedFrequency,
  skillRatee,
  setSkillRatee
}) => {
  const classes = useStyles();
  // const [selectedFrequency, setSelectedFrequency] = useState(null);
  // const [skillRatee, setSkillRatee] = useState({});
  const checkinDetails = useRecoilValue(checkinDetailSelector);
  const { allCheckinRatees } = checkinDetails;
  useEffect(() => {
    if (checkArrayLength(allCheckinRatees) && !allCheckinRatees.find(res => res.userid === skillRatee.userid)) {
      setSkillRatee(allCheckinRatees?.[0]);
    }
  }, [allCheckinRatees, skillRatee]);
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" className={classes.headerSection} key={skillRatee}>
        <UserFilter
          allCheckinRatees={allCheckinRatees || []}
          setSkillRatee={setSkillRatee}
          skillRatee={skillRatee}
        />
        {/* <FrequencyFilter
          selectedFrequency={selectedFrequency}
          setSelectedFrequency={setSelectedFrequency}
          checkinFrequencyDates={checkinFrequencyDates}
        /> */}
      </Box>
      <DownloadDropDown selectedFrequency={selectedFrequency} />
    </Box>
  );
};

export default HeaderFilters;
